import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL?.trim()
const key = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim()

/** Supabase sales-crm настроен — вход и справочники CRM через Supabase Auth. */
export function isSupabaseAuth(): boolean {
  return Boolean(url && key)
}

export const supabase = url && key ? createClient(url, key) : null
